
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type mobileGarageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function mobileGarageRT(): TemplateResult<mobileGarageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage vehical_dropdown' }, _createElement('a', {
        'className': 'garage-button align-items-center bg-transparent d-flex default fw-semibold lh-md text-capitalize vehical_toggle',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, _createElement('div', { 'className': 'garage-icon' }, [_createElement('svg', {
            'width': '30',
            'height': '24',
            'viewBox': '0 0 30 24',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '3110'
        }, _createElement('path', {
            'd': 'M27.0327 17.8045H28.741C28.9064 17.8045 29.0276 17.5811 28.9945 17.3298L28.4104 11.2836C28.3112 10.4737 27.8704 9.85929 27.3303 9.80344L22.4257 9.25886L17.9841 5.1536C17.8739 5.05585 17.7416 5 17.6094 5H11.9774C11.5696 5 11.25 5.50269 11.25 6.13104V9.38453H2C1.44772 9.38453 1 9.83225 1 10.3845V16.1662C1 16.5878 1.26449 16.9642 1.66122 17.107L4.14112 18',
            'stroke': 'currentColor',
            'strokeWidth': '1.25',
            'strokeMiterlimit': '10'
        }), _createElement('path', {
            'd': 'M21.984 17.9172H9.32031',
            'stroke': 'currentColor',
            'strokeWidth': '1.25',
            'strokeMiterlimit': '10'
        }), _createElement('path', {
            'd': 'M6.64062 21C8.02134 21 9.14062 19.8857 9.14062 18.5111C9.14062 17.1365 8.02134 16.0222 6.64062 16.0222C5.25991 16.0222 4.14062 17.1365 4.14062 18.5111C4.14062 19.8857 5.25991 21 6.64062 21Z',
            'stroke': 'currentColor',
            'strokeWidth': '1.25',
            'strokeMiterlimit': '10'
        }), _createElement('path', {
            'd': 'M24.1992 21C25.5799 21 26.6992 19.8857 26.6992 18.5111C26.6992 17.1365 25.5799 16.0222 24.1992 16.0222C22.8185 16.0222 21.6992 17.1365 21.6992 18.5111C21.6992 19.8857 22.8185 21 24.1992 21Z',
            'stroke': 'currentColor',
            'strokeWidth': '1.25',
            'strokeMiterlimit': '10'
        }))]))));
}
        export const componentNames = []